import React, { createContext, useContext, useEffect, useState } from 'react';

type ConsentStatus = 'granted' | 'denied' | null;

interface CookieConsentContextType {
  consent: ConsentStatus;
  setConsent: (status: ConsentStatus) => void;
  isConsentGiven: boolean;
}

const CookieConsentContext = createContext<CookieConsentContextType | undefined>(undefined);

export const CookieConsentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [consent, setConsentState] = useState<ConsentStatus>(null);

  useEffect(() => {
    const storedConsent = localStorage.getItem('cookie_consent');
    if (storedConsent === 'granted' || storedConsent === 'denied') {
      setConsentState(storedConsent);
    }
  }, []);

  const setConsent = (status: ConsentStatus) => {
    if (status) {
      localStorage.setItem('cookie_consent', status);
    }
    setConsentState(status);
  };

  const isConsentGiven = consent === 'granted';

  return (
    <CookieConsentContext.Provider value={{ consent, setConsent, isConsentGiven }}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsent = () => {
  const context = useContext(CookieConsentContext);
  if (context === undefined) {
    throw new Error('useCookieConsent must be used within a CookieConsentProvider');
  }
  return context;
};
